import FilterSectionSort from './FilterSectionSort';
import FilterSectionFacet from './FilterSectionFacet';
import FilterSectionPrice from './FilterSectionPrice';

function FilterList() {
  return (
    <div className="divide-y divide-greyscale-separator -mt-6">
      <FilterSectionSort />
      <FilterSectionPrice />
      <FilterSectionFacet facetKey="countries" filterKey="country" filterChildKey="region" />
      <FilterSectionFacet facetKey="characteristics" filterKey="characteristic" />
      <FilterSectionFacet facetKey="occasions" filterKey="occasion" />
    </div>
  );
}

export default FilterList;
